// extracted by mini-css-extract-plugin
module.exports = {"default":"Footer_default__34b5d","noMargin":"Footer_noMargin__1n6_E"};